import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// console.log("zdrw");

export default () => {
  const canvas = document.querySelector(".hero-animation canvas");
  const context = canvas.getContext("2d");

  const img = new Image();

  const currentFrame = (index) => `img/jpg-sequence/hero/intro-${index.toString().padStart(5, "0")}.jpg`;

  let frameCount = 137;
  let startAt = 60;

  // img.src = currentFrame(startAt);

  // canvas.width = 1920;
  // canvas.height = 1080;

  img.onload = function () {
    context.drawImage(img, 0, 0);
  };

  const updateImage = (index) => {
    img.src = currentFrame(index);
  };

  //   offset_value = 100;

  gsap.to(".images-container", {
    // backgroundPosition: -offset_value * frame_count * 2 + "px 50%",
    // ease: "steps(" + frame_count + ")", // use a stepped ease for the sprite sheet
    // y: "-100",
    // scale: 0.8,
    // x: "10%",
    scrollTrigger: {
      trigger: ".images-container",
      start: "top top",
      // end: "+=" + (frame_count * offset_value),
      // end: `+=${document.querySelector(".hero-animation").offsetHeight - window.innerHeight} `, // section height - window.innerheight
      end: () => `+=${document.querySelector(".hero-animation").offsetHeight - window.innerHeight} `,
      // end: "+=1349",
      pin: true,
      scrub: true,
      onUpdate: (self) => {
        // console.log("sticky inner: ", self.progress);
        const frameIndex = Math.min(frameCount - 1, startAt + Math.ceil(self.progress * (frameCount - startAt)));
        updateImage(frameIndex + 1);
        // console.log("updating image: ", frameIndex + 1);
      },
    },
  });

  // text scroll trigger

  const textTags = document.querySelectorAll(".intro span");

  // textTl.to(".hero-animation .canvas-wrapper", { x: "25%", duration: 300 }, 0);

  // move canvas tl

  gsap.fromTo(
    ".hero__about",
    {
      y: 0,
      opacity: 0,
    },
    {
      y: 0,
      opacity: 1,
      scrollTrigger: {
        trigger: ".hero__about",
        start: () => `top 80%`,
        end: "+=300",
        scrub: true,
      },
    }
  );

  const canvasTl = gsap.timeline({ paused: true });

  canvasTl.to(".hero-animation .canvas-wrapper", { x: window.matchMedia("(max-width: 640px)").matches ? 0 : "20%", duration: 300 });

  // canvasTl.to(".hero-animation .canvas-wrapper", { x: window.matchMedia("(max-width: 640px)").matches ? 0 : "100px", duration: 300 }, 0);

  ScrollTrigger.create({
    trigger: ".intro",
    scrub: true,
    // start: "top center",
    // end: `+=${document.querySelector(".intro-outer-container").offsetHeight - document.querySelector(".intro").offsetHeight}`,
    // start: "top center",
    // end: "bottom center",
    // end: "+=2000",
    // pin: true,
    onUpdate: (self) => {
      // console.log("zdrw", self.progress);
      // textTl.progress(self.progress);

      if (self.progress > 0.25 && self.progress < 0.5) {
        textTags[0].classList.add("active");
      } else {
        textTags[0].classList.remove("active");
      }

      if (self.progress >= 0.5 && self.progress <= 0.75) {
        textTags[1].classList.add("active");
      } else {
        textTags[1].classList.remove("active");
      }

      // const frameIndex = Math.min(frameCount - 1, startAt + Math.ceil(self.progress * (frameCount - startAt)));
      // updateImage(frameIndex + 1);

      // if (self.progress > 0.66) {
      //   textTags[2].classList.add("active");
      // } else {
      //   textTags[2].classList.remove("active");
      // }

      // if (!window.matchMedia("(max-width: 640px)").matches) {
      // canvasTl.progress(self.progress);
      // }

      // image.style.transform = `translateY(${-20 * self.progress * index}px)`;

      // image.querySelector("img").style.transform = `translateY(${-60 * self.progress * index}px)`;

      // console.log("image-wrapper: ", self.progress);
    },
  });

  // move background canvas to the right

  // ScrollTrigger.create({
  //   trigger: ".hero__about",
  //   start: "top center",
  //   onUpdate: (self) => {
  //     canvasTl.progress(self.progress);
  //   },
  // });

  gsap.fromTo(
    ".intro",
    {
      y: 0,
      opacity: 0,
    },
    {
      y: 0,
      opacity: 1,
      scrollTrigger: {
        trigger: ".intro",
        start: () => `top 80%`,
        end: "+=300",
        scrub: true,
      },
    }
  );

  // images wrapper parallax

  // document.querySelectorAll(".image-wrapper").forEach((image, index) => {
  //   ScrollTrigger.create({
  //     trigger: image,
  //     scrub: true,
  //     onUpdate: (self) => {
  //       image.querySelector("img").style.transform = `translateY(${-60 * self.progress * index}px)`;
  //     },
  //   });
  // });
};

//

// opacity on exit
gsap.to(".hero-animation .canvas-wrapper", {
  opacity: 0,
  scrollTrigger: {
    trigger: ".intro",
    start: "top 15%",
    end: "+=50%",
    scrub: true,
  },
});

// images

const introImages = document.querySelector(".intro-images");

// const imagesTl = gsap.timeline({ paused: true });

// introImages.querySelectorAll(".image-wrapper").forEach((imageWrapper, index) => {
//   imagesTl.fromTo(imageWrapper, { y: 100, opacity: 0 }, { y: 0, opacity: 1 }, "<");
// });

introImages.querySelectorAll(".image-wrapper").forEach((imageWrapper, index) => {
  // imagesTl.fromTo(imageWrapper, { y: 100, opacity: 0 }, { y: 0, opacity: 1 }, "<");

  // transform
  gsap.fromTo(
    imageWrapper,
    {
      // opacity: 0.5,
      y: 100 + parseInt(imageWrapper.getAttribute("data-intensity")) * 40,
    },
    {
      // opacity: 1,
      y: 0,
      scrollTrigger: {
        trigger: imageWrapper,
        // start: "top top",
        // end: "+=50%",
        scrub: true,
      },
    }
  );

  // opacity
  gsap.fromTo(
    imageWrapper.querySelector(".visual"),
    {
      opacity: 0,
    },
    {
      opacity: 1,
      // y: 0,
      scrollTrigger: {
        trigger: imageWrapper,
        // start: "top 15%",
        // start: "top top",
        end: "+=300",
        scrub: true,
      },
    }
  );
});

// gsap.fromTo(
//   ".hero-animation .canvas-wrapper",
//   {
//     opacity: 1,
//   },
//   {
//     opacity: 0,
//     scrollTrigger: {
//       trigger: ".hero-animation",
//       start: () => `bottom bottom+=500`,
//       end: "+=500",
//       scrub: true,
//       onEnter: () => {
//         console.log("entered wsup");
//       },
//     },
//   }
// );

// gsap.fromTo(
//   introImages,
//   {
//     opacity: 1,
//   },
//   {
//     opacity: 1,
//     scrollTrigger: {
//       trigger: introImages,
//       start: "top 10%",
//       end: "+=300",
//       // pin: true,
//       scrub: true,
//       opacity: 1,
//       // y: "-10rem",
//       onToggle: (self) => {
//         // console.log("hero images:", self.isActive)
//         // gsap.to(".hero-animation .canvas-wrapper", { opacity: self.isActive ? 0 : 1, duration: 0.5 });
//         // if ( self.isActive ) {
//         //   introImages.classList
//         // }
//         // gsap.fromTo(".intro-images .image-wrapper", { opacity: self.isActive ? 1 : 0, y: self.isActive ? 0 : 100 }, { opacity: self.isActive ? 0 : 1, y: self.isActive ? 0 : 100, duration: 0.5 });
//         //introImages.classList.toggle("intro-images--active", self.isActive);
//       },
//       onUpdate: (self) => {
//         console.log("ayooo progress zdrw", self.progress);
//         imagesTl.progress(self.progress);
//         // console.log("images entered");
//         // console.log("sticky inner: ", self.progress);
//         // const frameIndex = Math.min(frameCount - 1, startAt + Math.ceil(self.progress * (frameCount - startAt)));
//         // requestAnimationFrame(() => updateImage(frameIndex + 1));
//       },
//     },
//   }
// );
